import { ADD_RETURN } from '../constants/ActionTypes'
import { push } from 'connected-react-router'

export function addReturnSuccess(orderNumber, orderItem, returnLine) {
    return {
        type: ADD_RETURN,
        payload: {
            orderNumber,
            orderItem,
            returnLine
        }
    }
}

export default function addReturn(orderNumber, orderItem, returnLine, urlPath) {
    return (dispatch, getState) => {
        const { locale } = getState()

        dispatch(addReturnSuccess(orderNumber, orderItem, returnLine))
        dispatch(push(`/${locale.id}/account/${urlPath}/${orderNumber}/return`))
    }
}
